import { Grid } from '@mui/material';
import { ApexOptions } from 'apexcharts';
import { useState, useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';
import { getJobsCrmSMSSent } from 'wisestep-api';
import { WsTypography } from 'wisestep-base';

import { IAggregation, ISeriesDataType } from '../../types';

import IPayloadDTOJobsCrm from './types/IPayloadDTOJobsCrm';

const JobsCrmSMSSentAnalytics = ({ payload }: IPayloadDTOJobsCrm) => {
  const [aggregatedData, setAggregatedData] = useState<IAggregation[]>([]);
  const bucketData: ISeriesDataType[] = [];

  useEffect(() => {
    const fetchData = async () => {
      const response = await getJobsCrmSMSSent(payload);
      setAggregatedData(response.data.aggregations.aggregation.buckets);
    };
    fetchData();
  }, [payload]);

  aggregatedData.forEach((item) => {
    bucketData.push({ x: item.key_as_string ?? '', y: item.doc_count });
  });
  const options: ApexOptions = {
    chart: {
      height: 350,
      zoom: {
        enabled: true,
      },
    },
    title: {
      text: 'Submissions Trend',
    },
    xaxis: {
      type: 'datetime',
      title: {
        text: 'Day Sent',
      },
      labels: {
        datetimeUTC: false,
      },
    },
    yaxis: {
      title: {
        text: 'SMS Sent',
      },
    },
    dataLabels: {
      enabled: false,
    },
  };

  const series = [
    {
      data: bucketData,
      name: 'SMS Sent',
    },
  ];
  return (
    <Grid container justifyItems={'space-evenly'} spacing={2} textAlign="center">
      <Grid item xs={12}>
        <WsTypography> SMS Sent </WsTypography>
        <ReactApexChart options={options} series={series} type="bar" height={350} />
      </Grid>
    </Grid>
  );
};

export default JobsCrmSMSSentAnalytics;
